import { BrowserPrint } from "../../utils/BrowserPrint.js";
import i18n from "../../i18n";

export default {
    props: {
        disableButton: {
            type: Boolean,
            default: () => false
        }
    },
    data() {
        return {
            time: 2000,
            dialogm1: '',
            dialog: false,
            sctiker: [],
            barcode: '',
            print: [{
                    "id": 1,
                    "name": "Send To OneNote 2016"
                },
                {
                    "id": 2,
                    "name": "OneNote"
                },
                {
                    "id": 3,
                    "name": "Microsoft XPS Document Writer"
                },
                {
                    "id": 4,
                    "name": "Microsoft Print to PDF"
                },
                {
                    "id": 5,
                    "name": "Fax"
                },
                {
                    "id": 6,
                    "name": "\\\\192.168.12.139\\ZDesigner GK420t"
                },
                {
                    "id": 7,
                    "name": "\\\\192.168.12.26\\ZDesigner GK420t"
                }
            ],
            zpl: `^XA~TA000~JSN^LT0^MNW^MTT^PON^PMN^LH0,0^JMA^PR5,5~SD15^JUS^LRN^CI0^XZ
                ^XA
                ^MMT
                ^PW799
                ^LL0400
                ^LS0
                ^BY2,3,102^FT29,122^BCN,,Y,N
                ^FD#BARCODE#^FS
                ^FT550,42^A0N,25,24^FH\^FDValor C.M. $:^FS
                ^FT710,42^A0N,28,28^FB70,1,0,R^FH\^FD#SCALE_FEE#^FS
                ^FT550,78^A0N,25,24^FH\^FDValor Flete^FS
                ^FT725,78^A0N,28,28^FB56,1,0,R^FH\^FD#SHIPPING_FEE#^FS
                ^FT550,114^A0N,25,24^FH\^FDCantidad: ^FS
                ^FT744,115^A0N,28,28^FB37,1,0,R^FH\^FD#CONSECUTIVE#^FS
                ^FT35,176^A0N,25,24^FH\^FDNombre Paciente:^FS
                ^FT223,177^A0N,25,24^FH\^FD#PATIENT_NAME#^FS
                ^FT32,211^A0N,25,26^FH\^FDCiudad Entrega:^FS
                ^FT223,211^A0N,25,24^FH\^FD#CITY#^FS
                ^FT32,247^A0N,30,24^FH\^FDDireccion Entrega:^FS
                ^FT223,247^A0N,25,24^FH\^FD#ADDRESS#^FS
                ^FT30,285^A0N,25,24^FH\^FDTelefono Contaco:^FS
                ^FT224,285^A0N,25,24^FH\^FD#CELLPHONE#^FS
                ^FT33,321^A0N,23,24^FH\^FDObservacion:^FS
                ^FT33,361^A0N,25,24^FH\^FD#OBSERVATION#^FS
                ^PQ1,0,1,Y^XZ`
        }
    },
    methods: {
        probando() {
            console.log(this.$ref.dialogPrinter.stickerData);
            console.log(this.$ref.dialogPrinter.barcode);
            console.log('hola mundo!');
        },

        changePrinter() {
            this.defaultMode = false;
            this.selectedPrinter = null;

            if (this.availablePrinters == null) {
                this.$notify({
                    group: "app",
                    type: "info",
                    text: i18n.t("print-barcode-component.finding-printers")
                });

                setTimeout(changePrinter, 200);
                return;
            }

            this.selectedPrinter = this.availablePrinters[0];
        },

        emitClick() {
            this.$emit("buttonClick");
        },

        sendDataToPrinter(stickerData, barcode, printer) {
            if (!stickerData || stickerData == "") return;
            if (!barcode || barcode == "") return;
            if (!printer || printer == "") return;

            this.selectedPrinter = printer;
            if (!this.selectedPrinter) {
                this.configuratePrinter();
                this.printNoPrintersAvailable();
                return;
            }

            const finishedFunction = text => {
                if (text == "Ready to Print") {
                    this.$notify({
                        group: "app",
                        type: "info",
                        text: i18n.t("print-barcode-component.printing-in-process")
                    });

                    this.selectedPrinter.send(
                        this.zpl
                        .replace("#PATIENT_NAME#", stickerData.patientName)
                        .replace("#ADDRESS#", stickerData.address)
                        .replace("#CITY#", stickerData.city)
                        .replace("#CELLPHONE#", stickerData.cellphone)
                        .replace("#PHONE#", stickerData.phone)
                        .replace("#SCALE_FEE#", stickerData.scaleFee)
                        .replace("#SHIPPING_FEE#", stickerData.shippingFee)
                        .replace("#CONSECUTIVE#", stickerData.consecutive)
                        .replace("#OBSERVATION#", stickerData.observation)
                        .split("#BARCODE#")
                        .join(barcode)
                    );

                    this.$emit("print");
                } else {
                    this.printError(text);
                }
            };

            this.checkPrinterStatus(finishedFunction);
        },

        checkPrinterStatus(finishedFunction) {
            this.selectedPrinter.sendThenRead(
                "~HQES",
                function(text) {
                    var that = this;
                    var statuses = new Array();
                    var ok = false;
                    var is_error = text.charAt(70);
                    var media = text.charAt(88);
                    var head = text.charAt(87);
                    var pause = text.charAt(84);
                    // check each flag that prevents printing
                    if (is_error == "0") {
                        ok = true;
                        statuses.push("Ready to Print");
                    }
                    if (media == "1") statuses.push("Paper out");
                    if (media == "2") statuses.push("Ribbon Out");
                    if (media == "4") statuses.push("Media Door Open");
                    if (media == "8") statuses.push("Cutter Fault");
                    if (head == "1") statuses.push("Printhead Overheating");
                    if (head == "2") statuses.push("Motor Overheating");
                    if (head == "4") statuses.push("Printhead Fault");
                    if (head == "8") statuses.push("Incorrect Printhead");
                    if (pause == "1") statuses.push("Printer Paused");
                    if (!ok && statuses.Count == 0) statuses.push("Error: Unknown Error");
                    finishedFunction(statuses.join());
                },
                () => {
                    this.printerError(i18n.t("print-barcode-component.printing-error"));
                }
            );
        },

        printNoPrintersAvailable() {
            this.printError(i18n.t("print-barcode-component.no-printers-available"));
        },

        printError(text) {
            this.$notify({
                group: "app",
                type: "error",
                text: i18n.t(text)
            });
        }
    }
}